import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import moment from "moment";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faProjectDiagram,
  faPlay,
  faTrash,
  faPencilAlt
} from "@fortawesome/free-solid-svg-icons";
import GenericTooltip from "../../atoms/generic-tooltip";
import { URL_JDC_INTERPRETER } from "../../../constants";
import T from "../../atoms/translate";
import { t } from "../../../utils/utils";

const ProjectCard = props => {
  const deleteProject = () => {
    props.onDeleteProject();
  };
  return (
    <Col xs="6" md="3" lg="2" className="mb-3">
      <Card
        className={`h-100 box-shadow rounded-xg border-gris-100 ${
          !props.new ? "project-card" : ""
        }`}
      >
        {/* <CardImg top width="100%" src="/assets/318x180.svg" alt="Card image cap" /> */}
        <CardBody className="px-3 pb-1 pt-2">
          {props.new ? (
            <Row onClick={props.onClick} className="mt-2 cursor-pointer">
              <Col xs="12" className="mb-3 text-center text-blue">
                <FontAwesomeIcon
                  icon={props.new ? faPlus : faProjectDiagram}
                  size="3x"
                  className="text-primary"
                />
              </Col>
              <Col xs="12" className="my-2">
                <h1 className="mb-2 font-size-09 fw-600 text-center text-decoration">
                  <T i18nKey="crearProyecto" />
                </h1>
              </Col>
            </Row>
          ) : (
            <Row className="h-100 ">
              <Col xs="12" className="my-0 text-body">
                <GenericTooltip msg={t("tooltipTituloProyecto")}>
                  <Link
                    to={`/project/${props.slug}`}
                    className="text-decoration-none"
                  >
                    <h1 className="mb-0 font-size-08 fw-600 text-left">
                      {props.name}
                    </h1>
                  </Link>
                </GenericTooltip>
              </Col>
              <Col xs="12" className="text-left text-body mt-n2">
                <GenericTooltip
                  msg={moment(parseInt(props.updatedAt)).format(
                    t("tooltipFechaProyecto")
                  )}
                >
                  <span className="text-secondary font-size-07 mt-1">
                    {moment(parseInt(props.updatedAt)).format("DD-MM HH:mm")}
                  </span>
                </GenericTooltip>
              </Col>
              <Col xs="12" className="mb-0">
                <Row className="h-100 justify-content-end align-items-end">
                  <Col xs="12" className="px-1 text-right">
                    <GenericTooltip msg={t("tooltipTituloProyecto")}>
                      <Link
                        to={`/project/${props.slug}`}
                        className="btn btn-success btn-sm mr-1"
                      >
                        <FontAwesomeIcon icon={faPencilAlt} />
                      </Link>
                    </GenericTooltip>
                    <GenericTooltip msg={t("lanzarProyecto")}>
                      <a
                        href={`${URL_JDC_INTERPRETER}/project/${props.slug}`}
                        target="_mycontrolledtab"
                        className="btn btn-info btn-sm mr-1"
                      >
                        <FontAwesomeIcon icon={faPlay} />
                      </a>
                    </GenericTooltip>
                    <GenericTooltip msg={t("eliminarProyecto")}>
                      <Button size="sm" color="danger" onClick={deleteProject}>
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    </GenericTooltip>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

// Title.defaultProps = {
//   className: '',
//   children: '',
// }

export default ProjectCard;
